import InfoBeneficiaryStep0FormComponent from '../../components/info-beneficiary/InfoBeneficiaryStep0FormComponent';

export default function InfoBeneficiaryStep0Bloc() {

      return (
        <div className="">
          <div className=""> 
            <InfoBeneficiaryStep0FormComponent />
          </div>
        </div>
      )
}